import React from "react";
import { defineMessages } from "react-intl";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import { MessageOrientation } from "../../../components/alerts/Message.js";
import "@mui/material";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/editable/EditProvider.js";
import "../../../components/editable/EditButtonHoc.js";
import "../../../components/editable/EditableText.js";
import "../../../components/editable/EditableSelect.js";
import "uuid";
import { withEditableAutocomplete } from "../../../components/editable/EditableAutocomplete.js";
import { dashCharacter } from "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../shared-blocks/PlayerFinancialSummary.js";
import { ViewAutocomplete } from "../../shared-blocks/ViewAutocomplete.js";
import { isStringNullOrEmpty } from "../../../utils/string.js";
import "moment-timezone";
import { nameOf } from "../../../utils/object.js";
const localized = defineMessages({
  autocompleteDisplayName: {
    id: "PlayerIdAutocomplete_autocompleteDisplayName",
    defaultMessage: "Player ID"
  }
});
const PlayerIdAutocomplete = ({ value, onFormErrorStateChange, ...props }) => {
  const viewType = "PlayerIdAutocomplete";
  const selectedPlayer = value ? { uid: value } : null;
  function handleOptionsChange(options, inputValue) {
    if (onFormErrorStateChange) {
      if (!options?.length && inputValue) {
        onFormErrorStateChange("not_found");
      } else {
        onFormErrorStateChange(null);
      }
    }
  }
  function optionMapper(item) {
    const value2 = item?.uid;
    const filteredValue = !props.optionsFilter || props.optionsFilter(value2) ? value2 : null;
    return filteredValue ? { label: filteredValue, value: filteredValue } : null;
  }
  function valueMapper(value2) {
    return value2?.uid;
  }
  const filter = value ? { uid: value } : null;
  return props.mode === "Read" ? /* @__PURE__ */ React.createElement(LocalizedText, { label: !isStringNullOrEmpty(value) ? value : dashCharacter }) : /* @__PURE__ */ React.createElement(
    ViewAutocomplete,
    {
      ...props,
      value: selectedPlayer,
      viewType,
      entityType: "UserProfile",
      displayName: localized.autocompleteDisplayName,
      fields: [nameOf("uid")],
      optionMapper,
      valueMapper,
      errorMessageOrientation: MessageOrientation.Floating,
      filterKey: "uid",
      filter,
      validateFilter: () => true,
      mode: "server",
      onOptionsChange: handleOptionsChange,
      cleanDelay: 0
    }
  );
};
const EditablePlayerIdAutocomplete = withEditableAutocomplete(PlayerIdAutocomplete);
export {
  EditablePlayerIdAutocomplete,
  PlayerIdAutocomplete
};
//# sourceMappingURL=PlayerIdAutocomplete.js.map
